var _style, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVectorBackgroundValeurs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1620 1920",
    style: {
      enableBackground: "new 0 0 1620 1920"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FAF1E4;}\r\n\t.st1{fill:#F0D7AF;}\r\n\t.st2{fill:#F5E5CA;}\r\n\t.st3{fill:#EBCA94;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,878.4c162.1,239.6,355.5,498.9,369.8,750.7L1620,1790.3V90.8C972.3,257.9,593.8-174.2,26,85.1 c-9,4.1-17.7,8.2-26,12.5V878.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1620,67.8c-444.2-13.4-674,396.9-894.9,819c-99.4,190,502.5,361.7,894.9,451.5V67.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1620,1406.5c-144.1-23-301.6-58.8-403.2-95C990.9,1231,725.1,887.1,725.1,887.1 C426.9,1078.4,170.7,902.2,0,703.5v1053.7c246.5,49.5,502.4-5.8,507.4-5.8c4.2,0,638.4-15.8,1112.6-27.5V1406.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1620,1169.7c-294.9-296.8-894.9-282.6-894.9-282.6c441.6,818.1-222.6,863.6-222.6,863.6 S1286.4,2012,1620,1885.4V1169.7z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorBackgroundValeurs);
export default __webpack_public_path__ + "static/media/vector-background-valeurs.21de2cad594ab765df67cf821a5d4ffe.svg";
export { ForwardRef as ReactComponent };